interface PickingSparklingBirdIcon {
  className?: string
}

export const PickingSparklingBirdIcon: React.FC<PickingSparklingBirdIcon> = ({
  className = "",
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M30.449 38.793L30.4553 38.8052"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4553 38.793L34.4617 38.8052"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.4617 38.793L38.468 38.8052"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1763 22.1172L27.1831 22.1304"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.72373 13.6979L9.30148 24.4356C10.8038 27.3371 13.3972 29.523 16.5112 30.5124C19.6252 31.5018 23.0047 31.2137 25.9062 29.7114L30.0088 27.5872C31.1757 26.9869 32.1204 26.0297 32.7052 24.8551C33.2901 23.6804 33.4846 22.3497 33.2603 21.0568C33.036 19.7639 32.4048 18.5764 31.4585 17.6674C30.5122 16.7583 29.3003 16.1752 27.9995 16.003L19.9651 14.9637M0.55493 12.1763L8.30668 13.3485"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M30.4243 28.0039L31.1567 31.093L29.0568 28.712"
        stroke="white"
        strokeWidth="2.16061"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8855 30.4375L14.8855 38.7939"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.8286 31.0293L19.8286 38.7902"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M10.903 1.79003C9.46063 3.53149 8.58986 5.67507 8.40919 7.92905C8.22851 10.183 8.74671 12.438 9.89326 14.3869C11.0398 16.3359 12.759 17.8843 14.8169 18.8214C16.8748 19.7584 19.1715 20.0387 21.3944 19.6239"
        stroke="white"
        strokeWidth="1.91397"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.2654 7.65739L33.9871 12.1897L32.7088 7.65734L28.1764 6.37904L32.7087 5.10069L33.9871 0.568359L35.2654 5.10069L39.7977 6.37904L35.2654 7.65739Z"
        fill="#FFF440"
      />
    </svg>
  )
}
